import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-home" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `home.title`,
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-settings" */ './views/settings/SettingsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/definitions`,
        name: `${apiConstants.code}.definitions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-definitions" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `definitions.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/modules`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-modules" */ './views/module/ModuleBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.modules`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-modules" */ './views/module/ModuleList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `modules.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.modules.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-modules" */ './views/module/ModuleDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `modules.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.modules.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-modules" */ './views/module/ModuleDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `modules.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `modules.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/users`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-users" */ './views/user/UserBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.users`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-users" */ './views/user/UserList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `users.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.users.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-users" */ './views/user/UserDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `users.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.users.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-users" */ './views/user/UserDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `users.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `users.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/roles`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-roles" */ './views/role/RoleBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.roles`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-roles" */ './views/role/RoleList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `roles.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.roles.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-roles" */ './views/role/RoleDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `roles.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.roles.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-roles" */ './views/role/RoleDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `roles.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `roles.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/notifications`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-notifications" */ './views/notification/NotificationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.notifications`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-notifications" */ './views/notification/NotificationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.notifications.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-notifications" */ './views/notification/NotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.notifications.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-notifications" */ './views/notification/NotificationConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.titles`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.notifications.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-notifications" */ './views/notification/NotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `notifications.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/ogcremoteservices`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.ogc_remote_services`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `ogc_remote_services.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.ogc_remote_services.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `ogc_remote_services.title`,
                }
            },
            {
                path: ':id/resources',
                name: `${apiConstants.code}.ogc_remote_services.resources`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceView.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `ogc_remote_services.title`,
                }
            },
            {
                path: ':id/harvest',
                name: `${apiConstants.code}.ogc_remote_services.harvest`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceHarvest.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `ogc_remote_services.import_resources`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.ogc_remote_services.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-ogc_remote_services" */ './views/ogc_remote_service/OGCRemoteServiceDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `ogc_remote_services.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `ogc_remote_services.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/databasenotifications`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-databasenotifications" */ './views/database_notification/DatabaseNotificationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.database_notifications`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-databasenotifications" */ './views/database_notification/DatabaseNotificationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `database_notifications.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.database_notifications.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-databasenotifications" */ './views/database_notification/DatabaseNotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `database_notifications.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.database_notifications.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "backoffice-databasenotifications" */ './views/database_notification/DatabaseNotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `database_notifications.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `database_notifications.titles`,
        }
    },
];

export default routes;